import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Timer = createReactComponent("Timer", ["svg", defaultAttributes, [["line", {
  x1: "10",
  x2: "14",
  y1: "2",
  y2: "2",
  key: "ama88k"
}], ["line", {
  x1: "12",
  x2: "15",
  y1: "14",
  y2: "11",
  key: "111sbd"
}], ["circle", {
  cx: "12",
  cy: "14",
  r: "8",
  key: "1s0y89"
}]]]);
export default Timer;